<template>
  <div class="swiperComponent">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '0')" title="轮播页" name="0">
        <template slot="title">
          轮播页
          <span class="stop-blank" @click.stop></span>
          <div class="add-bg" @click.stop>
            <el-dropdown @command="handleCommand" trigger="click" v-if="swiperBackground.length < maxSwiperLength">
              <span class="el-dropdown-link icon-portal-plus"></span>
              <el-dropdown-menu slot="dropdown" class="bg-menu">
                <el-dropdown-item v-for="(list, index) in bgDropdownList" :key="'bgdrop_' + index" :command="list.type"
                  ><img :src="list.src" alt="" />{{ list.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '0')">
          <div class="swiper-page" v-if="swiperBackground && swiperBackground.length > 0">
            <slider-and-input
              v-if="thumbsSwiper && thumbsSwiper.length > 0"
              class="mb12"
              :value.sync="swiperHeight"
              title="高度"
              :sliderMax="100"
              tips=""
              suffix="%"
            />
            <draggable
              element="ul"
              v-model="swiperBackground"
              handle=".mover"
              ghost-class="ghost"
              chosen-class="chosen"
              @start="startDrag"
              @end="endDrag"
            >
              <li class="bg-item verticallyCenter" v-for="(item, index) in swiperBackground" :key="index">
                <i class="mover icondrag icon-portal-drag" :class="dragging ? 'dragging' : ''"></i>
                <span class="img"><img :src="item.imgUrl" alt="" /></span>
                <span v-if="item.type == 'img'" class="text overflowHid1">图片</span>
                <span v-else class="text overflowHid1">视频</span>
                <div class="btn-box">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                    ><span class="icon-portal-edit-1" @click.stop="handleCommand(item.type, 'edit', index)"></span
                  ></el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    :open-delay="1000"
                    ><span class="icon-portal-delete1" @click.stop="handleDel(index)"></span
                  ></el-tooltip>
                </div>
              </li>
            </draggable>
          </div>
        </div>
      </el-collapse-item>
      <!-- 方向 -->
      <!-- 速度 -->
      <!-- autoplay -->
      <!-- 点击切换效果 -->
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="轮播设置"
        name="1"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div class="mt12">
            <cx-check-box :value.sync="loop">循环切换</cx-check-box>
          </div>
          <div class="mt12">
            <cx-check-box :value.sync="autoPlay">自动切换</cx-check-box>
          </div>
          <div class="swiper-card mt8" v-if="autoPlay">
            <div class="verticallyCenter mt8">
              <span class="mr16">停留时间</span>
              <el-input
                v-inputHandle="{ this1, type: 'autoPlayDelay', min: 1 }"
                type="number"
                style="flex: 1"
                v-model="autoPlayDelay"
                placeholder="请输入"
              >
                <template slot="suffix">
                  <span class="suffix_text">s</span>
                </template>
              </el-input>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="轮播加载页"
        name="1"
      >
        <div>
          轮播加载图片
          <li class="bg-item verticallyCenter">
                <span class="img"  :style="coverStyle" @click="previewCover"><img alt="" :src="cover"/></span>
                <div class="btn-box">
                  <span class="icon-portal-edit-1" @click.stop="chooseCover"></span>
                </div>
              </li>
        </div>
      </el-collapse-item>
      <!-- 分页器点击切换 -->
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="分页指示器"
        name="3"
        v-if="!isThumbsSwiper"
      >
        <div style="width: 100%" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <div class="optionItem verticallyCenter">
            <el-checkbox v-model="showPagination">显示分页指示器</el-checkbox>
            <i class="tips-btn icon-portal-info2" @click="explainDialogClick('indicator')"></i>
          </div>
          <div class="pagination-set" v-if="showPagination">
            <el-collapse v-model="activeNamesPage">
              <el-collapse-item name="1">
                <template slot="title">指示器样式</template>
                <div class="verticallyCenter mt12">
                  <span class="mr16" style="width: 32px">类型</span>
                  <el-select v-model="paginationTypes" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in paginationType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <slider-and-input
                  v-if="paginationTypes == 'bullets'"
                  class="mt12 optionItem width72"
                  :value.sync="bulletsMargin"
                  title="大小"
                  :sliderMax="100"
                  suffix="px"
                />
                <slider-and-input
                  v-if="paginationTypes == 'bullets'"
                  class="mt12 optionItem width72"
                  :value.sync="bulletsSize"
                  title="间距"
                  :sliderMax="100"
                  suffix="px"
                />
                <div v-if="paginationTypes == 'fraction'" class="mt12">
                  <text-setting-complex-update
                    class="mb16"
                    :fontFamily.sync="fractionFontFamily"
                    :fontSize.sync="fractionFontSize"
                    :fontWeight.sync="fractionFontWeight"
                    :fontStyle.sync="fractionFontStyle"
                    :textDecoration.sync="fractionTextDecoration"
                    :lineHeight.sync="fractionLineHeight"
                    :lineHeightType.sync="fractionLineHeightType"
                    :letterSpacing.sync="fractionLetterSpacing"
                    :letterSpacingType.sync="fractionLetterSpacingType"
                    :writingMode.sync="fractionWritingMode"
                    :textAlign.sync="fractionTextAlign"
                    :activeArrangement.sync="fractionActiveArrangement"
                    :activeArrangementOrder.sync="fractionActiveArrangementOrder"
                    :enableVerticalAlign="showFractionVerticalAlign"
                    :isThemeColor.sync="fractionIsThemeColor"
                    :colorArr.sync="fractionColor"
                    :verticalAlign.sync="fractionVerticalAlign"
                    :options="options"
                  />
                </div>
                <slider-and-input
                  v-if="paginationTypes == 'progressbar'"
                  class="mt12 optionItem width72"
                  :value.sync="progressbarWidth"
                  title="宽度"
                  :sliderMax="100"
                  suffix="%"
                />
                <slider-and-input
                  v-if="paginationTypes == 'progressbar'"
                  class="mt12 optionItem width72"
                  :value.sync="progressbarHeight"
                  title="高度"
                  :sliderMax="100"
                  suffix="px"
                />
                <div v-if="paginationTypes == 'rectangle'">
                  <div class="verticallyCenter mt12">
                    <span class="mr16">默认尺寸</span>
                    <el-input
                      style="width: 63px"
                      class="mr12"
                      type="number"
                      v-inputHandle="{ this1, type: 'rectangleWidth' }"
                      v-model="rectangleWidth"
                      @focus="getFocus($event)"
                    >
                      <template slot="suffix">
                        <span class="suffix_text">宽</span>
                      </template>
                    </el-input>
                    <el-input
                      style="width: 63px"
                      type="number"
                      v-inputHandle="{ this1, type: 'rectangleHeight' }"
                      v-model="rectangleHeight"
                    >
                      <template slot="suffix">
                        <span class="suffix_text">高</span>
                      </template>
                    </el-input>
                  </div>
                  <div class="verticallyCenter mt12">
                    <span class="mr16">选中尺寸</span>
                    <el-input
                      style="width: 63px"
                      class="mr12"
                      type="number"
                      v-inputHandle="{ this1, type: 'rectangleActiveWidth' }"
                      v-model="rectangleActiveWidth"
                      @focus="getFocus($event)"
                    >
                      <template slot="suffix">
                        <span class="suffix_text">宽</span>
                      </template>
                    </el-input>
                    <el-input
                      style="width: 63px"
                      type="number"
                      v-inputHandle="{ this1, type: 'rectangleActiveHeight' }"
                      v-model="rectangleActiveHeight"
                    >
                      <template slot="suffix">
                        <span class="suffix_text">高</span>
                      </template>
                    </el-input>
                  </div>
                  <slider-and-input
                    class="mt12 optionItem width72"
                    :value.sync="bulletsRadius"
                    title="圆角"
                    :sliderMax="100"
                    suffix="px"
                  />
                  <slider-and-input
                    class="mt12 optionItem width72"
                    :value.sync="bulletsSize"
                    title="间距"
                    :sliderMax="100"
                    suffix="px"
                  />
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">位置</template>
                <div class="verticallyCenter mt8" v-if="paginationTypes === 'progressbar'">
                  <span class="mr16">位置</span>
                  <div class="font-arrangement-btn height32 flex1">
                    <span class="btn-active" :style="getTranslate3"></span>
                    <span
                      v-for="(val, index) in positionList1"
                      :key="index"
                      :class="paginationPosition == val.label ? 'select pd2' : 'pd2'"
                      @click="changePosition(val.label, index)"
                      style="font-size: 13px"
                      >{{ val.title }}</span
                    >
                  </div>
                </div>
                <pagination-set
                  v-else
                  class="mt8"
                  :paginationPosition.sync="paginationPosition"
                  :paginationLeft.sync="paginationLeft"
                  :paginationRight.sync="paginationRight"
                  :paginationTop.sync="paginationTop"
                  :paginationBottom.sync="paginationBottom"
                />
                <slider-and-input
                  v-if="paginationTypes === 'progressbar'"
                  class="mt12 optionItem width72"
                  :value.sync="progressbarDrift"
                  title="偏移"
                  :sliderMax="1920"
                  suffix="px"
                />
              </el-collapse-item>
              <el-collapse-item name="3" v-if="paginationTypes != 'fraction'">
                <template slot="title">颜色设置</template>
                <div v-show="paginationTypes === 'bullets' || paginationTypes === 'rectangle'">
                  <div class="verticallyCenter mt12">
                    <span class="mr16">默认颜色</span>
                    <cx-color-picker
                      class="flex1 lableWidth4"
                      :isThemeColor.sync="bulletsPrimaryIsTheme"
                      :colorArr.sync="bulletsPrimaryColor"
                    >
                    </cx-color-picker>
                  </div>
                  <div class="verticallyCenter mt12">
                    <span class="mr16">选中颜色</span>
                    <cx-color-picker
                      class="flex1"
                      style="width: 138px"
                      :isThemeColor.sync="bulletsActiveIsTheme"
                      :colorArr.sync="bulletsActiveColor"
                    >
                    </cx-color-picker>
                  </div>
                </div>
                <div v-show="paginationTypes === 'progressbar'">
                  <div class="verticallyCenter mt12">
                    <span class="mr16">默认颜色</span>
                    <cx-color-picker
                      class="flex1 lableWidth4"
                      :isThemeColor.sync="bulletsPrimaryIsTheme"
                      :colorArr.sync="bulletsPrimaryColor"
                    >
                    </cx-color-picker>
                  </div>
                  <div class="verticallyCenter mt12">
                    <span class="mr16">选中颜色</span>
                    <cx-color-picker
                      class="flex1"
                      style="width: 138px"
                      :isThemeColor.sync="progressbarIsTheme"
                      :colorArr.sync="progressbarBackground"
                    >
                    </cx-color-picker>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="bg-set-dialog-wrap padding12" @click.stop="closebgSetStatu" v-show="showBgSetDialog">
      <!-- 图片设置 -->
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showImgSet && bgItem">
        <img-upload :imgSrc.sync="bgItem.imgUrl" imgSize="1920*500" :maxSize="5" />
        <p class="tips">链接地址</p>
        <el-input type="text" class="mb8" v-model="bgItem.linkUrl" placeholder="请输入https://开头的地址"></el-input>
        <el-checkbox v-model="bgItem.openBlank">新页面打开</el-checkbox>
      </div>
      <!-- 视频设置 -->
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showVideoSet && bgItem">
        <div class="video-source-box">
          <div class="video-bgcard">
            <div class="uploadfailed" v-if="percentage == 'error'">
              <i class="icon-portal-attention"></i>
              <p class="text">上传失败</p>
            </div>
            <div class="uploading" v-else-if="percentage > 0">
              <el-progress
                type="circle"
                :percentage="percentage"
                :width="36"
                :show-text="false"
                :color="themeColor"
              ></el-progress>
              <p class="text">{{ percentage }}%</p>
            </div>
            <img :src="bgItem.imgUrl || defaultVideoBg" alt="" v-else />
          </div>
          <div class="video-upload-box">
            <p class="tips">格式：FIV、MP4<br />大小：2G以下</p>
            <el-upload
              name="file"
              action="https://pan-yz.chaoxing.com/upload"
              accept=".mp4,.m3u8"
              :data="actionData"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handleSuccessHandle"
              :on-error="handleFailHandle"
              :on-progress="handleProgressHandle"
              :show-file-list="false"
            >
              <button class="video-upload-btn">点击上传</button>
            </el-upload>
          </div>
          <el-checkbox class="mt12" v-model="loop">循环播放</el-checkbox>
          <div class="mb8">
            <el-checkbox class="mt12" v-model="autoPlay">自动播放</el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div v-if="explainImgSrc || explainVideoSrc" class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  _throttle,
  _debounce
} from "utils"
import button from "./settings/button.vue"
import { Swiper3D as SwiperDep } from "../menus/model.js"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import draggable from "vuedraggable"
import default_video_fm from "assets/images/image_placeholder.png"
import {
  updateSubPageMapping,
  addSubPageMapping
} from "utils/updateData/publicDataUtils/subPageUpdateData.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { withMethodsHistoryCombine, historyCombineWrap } from "utils/revork"

const baseSwiper = new SwiperDep()
export default withMethodsHistoryCombine({
  components: {
    Button: button,
    controlWidthAndSizeAndZindex,
    draggable
  },
  name: "swiper-options",
  props: {
    options: { type: Object },
    container_id: { type: Number, default: null },
    rect_id: { type: Number, default: null }
  },
  data() {
    return {
      this1: this,
      defaultAutoPlay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      activeNames: ["0", "1", "2", "3", "4", "5"],
      allCollapseNames: [],
      collapseActiveNames: ["0", "1", "2", "3", "4", "5"],
      activeNames2: [],
      paginationPositionSelect: [
        { label: "底部", value: "bottom" },
        { label: "顶部", value: "top" },
        { label: "左侧", value: "left" },
        { label: "右侧", value: "right" }
      ],
      paginationType: [
        { label: "圆点", value: "bullets" },
        // { label: "无", value: "none" },
        { label: "分数", value: "fraction" },
        { label: "进度条", value: "progressbar" },
        { label: "矩形", value: "rectangle" }
      ],
      effect: [
        { label: "左右滑动", value: "slide" },
        { label: "淡入淡出", value: "fade" }
        // { label: "方块", value: "cube" },
        // { label: "3d流", value: "coverflow" },
        // { label: "卡片", value: "cards" },
        // { label: "3d翻转", value: "flip" }
      ],
      dragging: false,
      bgDropdownList: [
        { type: "img", label: "图片", src: require("../../../assets/images/icon-img.png") },
        { type: "video", label: "视频", src: require("../../../assets/images/icon-video.png") }
      ],
      showBgSetDialog: false,
      defaultImg: {
        type: "img",
        label: "图片",
        imgUrl: "",
        linkUrl: "",
        openBlank: true
      },
      defaultVideo: {
        type: "video",
        label: "视频",
        imgUrl: "",
        loopPlay: true,
        autoplay: true
      },
      showBgSetArr: {
        showImgSet: false,
        showVideoSet: false
      },
      actionData: {},
      percentage: 0,
      bgItem: [],
      bgItemIndex: undefined,
      defaultVideoBg: default_video_fm,
      directionList: [
        {
          className: "icon-portal-direction-h",
          label: "horizontal",
          title: "水平"
        },
        {
          className: "icon-portal-direction-v",
          label: "vertical",
          title: "垂直"
        }
      ],
      translate: 0,
      switchList: [],
      leftRightList: [
        {
          className: "icon-portal-direction-left",
          label: "right",
          title: "向左切换"
        },
        {
          className: "icon-portal-direction-right",
          label: "left",
          title: "向右切换"
        }
      ],
      topBottomList: [
        {
          className: "icon-portal-direction-up",
          label: "top",
          title: "向上切换"
        },
        {
          className: "icon-portal-direction-down",
          label: "bottom",
          title: "向下切换"
        }
      ],
      translate1: 0,
      activeNamesPage: ["1", "2", "3"],
      activeNamesThumbnail: ["1", "2"],
      thumbsStatus: 0,
      statusList: [
        {
          label: "0",
          title: "默认状态"
        },
        {
          label: "1",
          title: "选中状态"
        }
      ],
      translate2: 0,
      translate3: 0,
      positionList1: [
        {
          label: "top",
          title: "上"
        },
        {
          label: "bottom",
          title: "下"
        }
      ],
      positionList2: [
        {
          label: "left",
          title: "左"
        },
        {
          label: "right",
          title: "右"
        }
      ],
      changeTypeList: [
        {
          label: "single",
          title: "单条"
        },
        {
          label: "all",
          title: "整页"
        }
      ],
      translate4: 0,
      effectRotateSrc: require("../../../assets/images/tipsVideoImg/effect-rotate.mp4"),
      stretchSrc: require("../../../assets/images/tipsVideoImg/stretch.mp4"),
      depthSrc: require("../../../assets/images/tipsVideoImg/depth.mp4"),
      collapse: {
        top: {
          title: "标题栏",
          type: "top",
          isActive: true
        },
        bottom: {
          title: "底部栏",
          type: "bottom",
          isActive: true
        },
        left: {
          title: "左侧栏",
          type: "left",
          isActive: true
        },
        right: {
          title: "右侧栏",
          type: "right",
          isActive: true
        },
        list: {
          title: "列表页",
          type: "list",
          isActive: true
        },
        detail: {
          title: "详情页",
          type: "detail",
          isActive: true
        }
      },
      currentListPageCover: "",
      currentListPageTitle: "",
      currentDetailPageCover: "",
      currentDetailPageTitle: "",
      subPageSettingIndex: 0,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      isListPageEditStatus: false,
      isDetailPageEditStatus: false
    }
  },
  computed: {
    cover() {
      return this.options.swiperCover ? `https://p.ananas.chaoxing.com/star3/origin/${this.options.swiperCover}.png` : ''
    },
    coverStyle() {
      return {
        cursor: this.options.swiperCover ? 'zoom-in' : 'unset'
      }
    },
    maxSwiperLength() {
      if (this.options.styleId === 2) return 9
      return 10
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getDragBoxStyle() {
      return function (index) {
        const check = this.dragging === false || (typeof this.dragging !== Boolean && this.dragging !== index)
        return {
          left: this.mouseL - this.dragBoxL - this.mouseToDragBoxL + 2 + "px",
          top: this.mouseT - this.dragBoxT - this.mouseToDragBoxT - 6 + "px",
          width: check ? "100%" : this.dragBoxW + "px",
          height: check ? "34px" : this.dragBoxH + "px",
          position: check ? "" : "fixed",
          cursor: check ? "" : "grabbing"
        }
      }
    },
    getRectId() {
      let ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      }
      if (this.ids.elementInAutoLayoutId !== undefined && this.ids.elementInAutoLayoutId !== null) {
        ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
      }
      return ids
    },
    isChild() {
      if (this.ids.uid) return true
      else return false
    },
    swiperKey() {
      return this.options.swiperKey
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "left", false, null, this.getRectId)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "top", false, null, this.getRectId)
      }
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "width", false, null, this.getRectId)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "height", false, null, this.getRectId)
      }
    },
    rotate: {
      get() {
        return this.options.rotate
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false, null, this.getRectId)
      }
    },
    bulletsPrimaryColor: {
      get() {
        return this.options.pagination.bulletsPrimaryColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsPrimaryColor", true, "pagination", this.getRectId)
      }
    },
    bulletsPrimaryIsTheme: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "bulletsPrimaryIsTheme", "bulletsPrimaryIsTheme", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsPrimaryIsTheme", false, null, this.getRectId)
      }
    },
    bulletsActiveIsTheme: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "bulletsActiveIsTheme", "bulletsActiveIsTheme", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsActiveIsTheme", false, null, this.getRectId)
      }
    },
    bulletsActiveColor: {
      get() {
        return this.options.pagination.bulletsActiveColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsActiveColor", true, "pagination", this.getRectId)
      }
    },
    progressbarBackground: {
      get() {
        return this.options.progressbarBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "progressbarBackground", false, null, this.getRectId)
      }
    },
    progressbarIsTheme: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "progressbarIsTheme", "progressbarIsTheme", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "progressbarIsTheme", false, null, this.getRectId)
      }
    },
    swiperCover: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "swiperCover", "swiperCover", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "swiperCover", false, null, this.getRectId)
      }
    },
    progressbarHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "progressbarHeight", "progressbarHeight", 6)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "progressbarHeight", false, null, this.getRectId)
      }
    },
    progressbarWidth: {
      get() {
        this.checkAndSetPrimaryVal(this.options, "progressbarWidth", "progressbarWidth", 100)
        return this.options.hasOwnProperty("progressbarWidth") ? this.options.progressbarWidth : 100
      },
      set(newVal) {
        console.log("newVal", newVal)
        this.$changeOptionsEV(newVal, "progressbarWidth", false, null, this.getRectId)
      }
    },
    showPagination: {
      get() {
        return this.options.showPagination
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showPagination", false, null, this.getRectId)
      }
    },
    loop: {
      get() {
        return this.options.loop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loop", false, null, this.getRectId)
      }
    },
    autoPlay: {
      get() {
        return !!this.options.autoPlay
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "autoPlay", false, null, this.getRectId)
      }
    },
    autoPlayDelay: {
      get() {
        return this.options.autoPlayDelay
      },
      set(newVal) {  
        this.$changeOptionsEV(newVal, "autoPlayDelay", false, null, this.getRectId)
      }
    },
    zoomImage: {
      get() {
        return this.options.hasOwnProperty("zoomImage") ? this.options.zoomImage : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "zoomImage", false, null, this.getRectId)
      }
    },
    showBigButton: {
      get() {
        return this.options.hasOwnProperty("showBigButton") ? this.options.showBigButton : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showBigButton", false, null, this.getRectId)
      }
    },
    showBigPagination: {
      get() {
        return this.options.hasOwnProperty("showBigPagination") ? this.options.showBigPagination : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showBigPagination", false, null, this.getRectId)
      }
    },
    showZoomButton: {
      get() {
        return this.options.hasOwnProperty("showZoomButton") ? this.options.showZoomButton : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showZoomButton", false, null, this.getRectId)
      }
    },
    paginationTypes: {
      get() {
        return this.options.pagination.type
      },
      set(newVal) {
        if (!this.showPagination) {
          this.$changeOptionsEV([true, newVal], ["showPagination", "pagination.type"], false, null, this.getRectId)
        } else {
          this.$changeOptionsEV(newVal, "type", true, "pagination", this.getRectId)
        }
      }
    },
    paginationClickable: {
      get() {
        return this.options.pagination.clickable
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clickable", true, "pagination", this.getRectId)
      }
    },
    paginationPosition: {
      get() {
        return this.options.paginationPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paginationPosition", false, null, this.getRectId)
      }
    },
    paginationLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paginationLeft", "paginationLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paginationLeft", false, null, this.getRectId)
      }
    },
    paginationRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paginationRight", "paginationRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paginationRight", false, null, this.getRectId)
      }
    },
    paginationTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paginationTop", "paginationTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paginationTop", false, null, this.getRectId)
      }
    },
    paginationBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paginationBottom", "paginationBottom", 20)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paginationBottom", false, null, this.getRectId)
      }
    },
    progressbarDrift: {
      get() {
        if (this.paginationPosition === "top") return this.paginationTop
        if (this.paginationPosition === "bottom") return this.paginationBottom
        if (this.paginationPosition === "left") return this.paginationLeft
        if (this.paginationPosition === "right") return this.paginationRight
      },
      set(newVal) {
        if (this.paginationPosition === "top") this.paginationTop = newVal
        if (this.paginationPosition === "bottom") this.paginationBottom = newVal
        if (this.paginationPosition === "left") this.paginationLeft = newVal
        if (this.paginationPosition === "right") this.paginationRight = newVal
      }
    },
    bulletsSize: {
      get() {
        return this.options.bulletsSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsSize", false, null, this.getRectId)
      }
    },
    fractionFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionFontFamily", "fractionFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionFontFamily", true, "pagination", this.getRectId)
      }
    },
    fractionFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionFontSize", "fractionFontSize", 14)
      },
      set(newVal) {
        this.fractionLineHeight = newVal > this.fractionLineHeight ? newVal : this.fractionLineHeight
        this.$changeOptionsEV(newVal, "fractionFontSize", true, "pagination", this.getRectId)
      }
    },
    fractionFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionFontWeight", "fractionFontWeight", 400)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionFontWeight", true, "pagination", this.getRectId)
      }
    },
    fractionFontStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionFontStyle", "fractionFontStyle", "normal")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionFontStyle", true, "pagination", this.getRectId)
      }
    },
    fractionTextDecoration: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionTextDecoration", "fractionTextDecoration", "none")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionTextDecoration", true, "pagination", this.getRectId)
      }
    },
    fractionLineHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionLineHeight", "fractionLineHeight", 34)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionLineHeight", true, "pagination", this.getRectId)
      }
    },
    fractionLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionLineHeightType", "fractionLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionLineHeightType", true, "pagination", this.getRectId)
      }
    },
    fractionLetterSpacing: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionLetterSpacing", "fractionLetterSpacing", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionLetterSpacing", true, "pagination", this.getRectId)
      }
    },
    fractionLetterSpacingType: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.pagination,
          "fractionLetterSpacingType",
          "fractionLetterSpacingType",
          "px"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionLetterSpacingType", true, "pagination", this.getRectId)
      }
    },
    fractionWritingMode: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.pagination,
          "fractionWritingMode",
          "fractionWritingMode",
          "horizontal-tb"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionWritingMode", true, "pagination", this.getRectId)
        this.fractionVerticalAlign = "top"
      }
    },
    fractionTextAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionTextAlign", "fractionTextAlign", "center")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionTextAlign", true, "pagination", this.getRectId)
      }
    },
    fractionActiveArrangement() {
      return this.options.fractionTextAlign
    },
    fractionActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.fractionWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(newVal, "fractionWritingMode", true, "pagination", this.getRectId)
      }
    },
    fractionVerticalAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.pagination, "fractionVerticalAlign", "fractionVerticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionVerticalAlign", true, "pagination", this.getRectId)
      }
    },
    fractionIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "fractionIsThemeColor", "fractionIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionIsThemeColor", false, null, this.getRectId)
      }
    },
    fractionColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "fractionColor", "fractionColor", "#ffffff")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fractionColor", false, null, this.getRectId)
      }
    },
    showFractionVerticalAlign() {
      return this.fractionWritingMode !== "vertical-lr"
    },
    bulletsMargin: {
      get() {
        return this.options.bulletsMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bulletsMargin", false, null, this.getRectId)
      }
    },

    pagination: {
      get() {
        return this.options.pagination
      },
      set(newVal) {}
    },
    slidesPerView: {
      get() {
        return this.options.slidesPerView
      },
      set(newVal) {
        if (this.slidesPerView !== newVal) {
          this.$changeOptionsEV(newVal, "slidesPerView", false, null, this.getRectId)
        }
      }
    },
    showSlidesPerView: {
      get() {
        return this.options.showSlidesPerView
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showSlidesPerView", false, null, this.getRectId)
      }
    },
    effects: {
      get() {
        return this.options.effect
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "effect", false, null, this.getRectId)
        if (newVal === "fade") {// 淡入淡出
          this.slidesPerView = 1
        }
      }
    },
    crossFade: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "fadeEffect.crossFade",
          "crossFade",
          baseSwiper.fadeEffect.crossFade
        )
      },
      set(newVal) {
        if (!this.options.fadeEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.fadeEffect, crossFade: newVal },
            "fadeEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "crossFade", true, "fadeEffect", this.getRectId)
        }
      }
    },
    showBigImg: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showBigImg", "showBigImg", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showBigImg", false, null, this.getRectId)
      }
    },
    slideShadows: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "cubeEffect.slideShadows",
          "slideShadows",
          baseSwiper.cubeEffect.slideShadows
        )
      },
      set(newVal) {
        if (!this.options.cubeEffect) {
          this.$changeOptionsEV(
            { ...baseSwiper.cubeEffect, slideShadows: newVal },
            "cubeEffect",
            false,
            null,
            this.getRectId
          )
        } else {
          this.$changeOptionsEV(newVal, "slideShadows", true, "cubeEffect", this.getRectId)
        }
      }
    },
    shadow: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "cubeEffect.shadow", "shadow", baseSwiper.cubeEffect.shadow)
      },
      set(newVal) {
        if (!this.options.cubeEffect) {
          this.$changeOptionsEV({ ...baseSwiper.cubeEffect, shadow: newVal }, "cubeEffect", false, null, this.getRectId)
        } else {
          this.$changeOptionsEV(newVal, "shadow", true, "cubeEffect", this.getRectId)
        }
      }
    },
    content: {
      get() {
        return this.options.content
      }
    },
    speed: {
      get() {
        return this.options.speed
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "speed", false, null, this.getRectId)
      }
    },
    swiperContent: {
      get() {
        return this.options.hasOwnProperty("content") ? this.options.content.length : 0
      },
      set(newVal) {
        if (this.swiperContent == newVal) return
        if (newVal < this.swiperContent) {
          let data = {
            ...this.ids,
            mode: "sub"
          }
          delete data.swiperContent_id
          this.$store.dispatch(this.request_prefix + "/swiperContentControl", data)
        } else {
          let data = {
            ...this.ids,
            mode: "add"
          }
          delete data.swiperContent_id
          this.$store.dispatch(this.request_prefix + "/swiperContentControl", data)
        }
      }
    },
    swiper() {
      if (this.options !== null) {
        return {
          speed: this.options.speed,
          bgurl: [],
          content: this.options.content
        }
      }
      if (this.options == null && this.ids.uid !== null) {
        let result = JSON.parse(window.localStorage.getItem("tempOptions"))
        return {
          speed: result.speed,
          bgurl: [],
          content: result.content
        }
      }
      return null
    },
    ids() {
      return this.$store.state.states.activeID
    },
    swiperBackground: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "dataList", "dataList", [])
      },
      set(val) {
        this.$changeOptionsEV(val, "dataList", false, null, this.getRectId)
      }
    },
    thumbsSwiper: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsSwiper", "thumbsSwiper", [])
      },
      set(val) {
        this.$changeOptionsEV(val, "thumbsSwiper", false, null, this.getRectId)
      }
    },
    swiperType: {
      get() {
        let type = this.checkAndSetPrimaryVal(this.options, "swiperType", "swiperType", "horizontal")
        let index = this.directionList.findIndex(item => item.label === type)
        // 67.5 一个滑块的宽度
        this.translate = 67.5 * index
        if (type == "horizontal") {
          this.switchList = this.leftRightList
        } else {
          this.switchList = this.topBottomList
        }
        return type
      },
      set(newVal) {
        let index = this.directionList.findIndex(item => item.label === newVal)
        this.translate = 67.5 * index
        if (newVal == "horizontal") {
          this.switchList = this.leftRightList
        } else {
          this.switchList = this.topBottomList
        }
        this.$changeOptionsEV(newVal, "swiperType", false, null, this.getRectId)
      }
    },
    openZoom: {
      get() {
        return this.options.hasOwnProperty("openZoom") ? this.options.openZoom : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openZoom", false, null, this.getRectId)
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    switchType: {
      get() {
        let type = this.checkAndSetPrimaryVal(this.options, "switchType", "switchType", "left")
        let index = this.leftRightList.findIndex(item => item.label === type)
        // 62 一个滑块的宽度
        this.translate1 = 62 * index
        return type
      },
      set(newVal) {
        let index = this.leftRightList.findIndex(item => item.label === newVal)
        this.translate1 = 62 * index
        this.$changeOptionsEV(newVal, "switchType", false, null, this.getRectId)
      }
    },
    getTranslate1() {
      return {
        transform: `translateX(${this.translate1}px)`
      }
    },
    middlePage: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "middlePage", "middlePage", 60)
      },
      set(val) {
        this.$changeOptionsEV(val, "middlePage", false, null, this.getRectId)
      }
    },
    sliderMargin: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "sliderMargin", "sliderMargin", 16)
      },
      set(val) {
        this.$changeOptionsEV(val, "sliderMargin", false, null, this.getRectId)
      }
    },
    rectangleWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rectangleWidth", "rectangleWidth", 12)
      },
      set(val) {
        this.$changeOptionsEV(val, "rectangleWidth", false, null, this.getRectId)
      }
    },
    rectangleHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rectangleHeight", "rectangleHeight", 8)
      },
      set(val) {
        this.$changeOptionsEV(val, "rectangleHeight", false, null, this.getRectId)
      }
    },
    rectangleActiveWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rectangleActiveWidth", "rectangleActiveWidth", 4)
      },
      set(val) {
        this.$changeOptionsEV(val, "rectangleActiveWidth", false, null, this.getRectId)
      }
    },
    rectangleActiveHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rectangleActiveHeight", "rectangleActiveHeight", 2)
      },
      set(val) {
        this.$changeOptionsEV(val, "rectangleActiveHeight", false, null, this.getRectId)
      }
    },
    bulletsRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "bulletsRadius", "bulletsRadius", 0)
      },
      set(val) {
        this.$changeOptionsEV(val, "bulletsRadius", false, null, this.getRectId)
      }
    },
    swiperHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "swiperHeight", "swiperHeight", 70)
      },
      set(val) {
        this.$changeOptionsEV(val, "swiperHeight", false, null, this.getRectId)
      }
    },
    isThumbsSwiper: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isThumbsSwiper", "isThumbsSwiper", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isThumbsSwiper", false, null, this.getRectId)
      }
    },
    thumbsPerView: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsPerView", "thumbsPerView", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPerView", false, null, this.getRectId)
      }
    },
    thumbsHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsHeight", "thumbsHeight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsHeight", false, null, this.getRectId)
      }
    },
    thumbsMargin: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsMargin", "thumbsMargin", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsMargin", false, null, this.getRectId)
      }
    },
    // 边距
    thumbsPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("thumbsPaddingTypeFlag")) {
          if (
            ((this.thumbsPaddingTop === this.thumbsPaddingRight) === this.thumbsPaddingLeft) ===
            this.thumbsPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "thumbsPaddingTypeFlag", "thumbsPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPaddingTypeFlag", false, null, this.getRectId)
      }
    },
    thumbsPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsPadding", "thumbsPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPadding", false, null, this.getRectId)
      }
    },
    thumbsPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsPaddingTop", "thumbsPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPaddingTop", false, null, this.getRectId)
      }
    },
    thumbsPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsPaddingRight", "thumbsPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPaddingRight", false, null, this.getRectId)
      }
    },
    thumbsPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsPaddingLeft", "thumbsPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPaddingLeft", false, null, this.getRectId)
      }
    },
    thumbsPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsPaddingBottom", "thumbsPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsPaddingBottom", false, null, this.getRectId)
      }
    },
    thumbsBackground: {
      get() {
        let background = this.checkAndSetPrimaryVal(this.options, "thumbsBackground", "thumbsBackground", "")
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.thumbsBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.thumbsBgIsTheme,
            color: ""
          }
        ]
        this.$changeOptionsEV(newBackground, "thumbsBackground", false, null, this.getRectId, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBackground", false, null, this.getRectId)
      }
    },
    thumbsBgIsTheme: {
      get() {
        return this.options.hasOwnProperty("thumbsBgIsTheme") ? this.options.thumbsOpacity : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBgIsTheme", false, null, this.getRectId)
      }
    },
    getTranslate2() {
      return {
        transform: `translateX(${this.translate2}px)`
      }
    },
    thumbsOpacity: {
      get() {
        return this.options.hasOwnProperty("thumbsOpacity") ? this.options.thumbsOpacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsOpacity", false, null, this.getRectId)
      }
    },
    thumbsBorderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderTopLeftRadius") ? this.options.thumbsBorderTopLeftRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderTopLeftRadius", false, null, this.getRectId)
      }
    },
    thumbsBorderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderTopRightRadius") ? this.options.thumbsBorderTopRightRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderTopRightRadius", false, null, this.getRectId)
      }
    },
    thumbsBorderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderBottomRightRadius")
          ? this.options.thumbsBorderBottomRightRadius
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderBottomRightRadius", false, null, this.getRectId)
      }
    },
    thumbsBorderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderBottomLeftRadius")
          ? this.options.thumbsBorderBottomLeftRadius
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderBottomLeftRadius", false, null, this.getRectId)
      }
    },
    thumbsBorderRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderRadius") ? this.options.thumbsBorderRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "thumbsBorderRadius",
            "thumbsBorderTopLeftRadius",
            "thumbsBorderTopRightRadius",
            "thumbsBorderBottomRightRadius",
            "thumbsBorderBottomLeftRadius"
          ],
          false,
          null,
          this.getRectId
        )
      }
    },
    thumbsBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("thumbsBorderTypeFlag")) {
          if (
            ((this.thumbsBorderTopLeftRadius === this.thumbsBorderTopRightRadius) ===
              this.thumbsBorderBottomLeftRadius) ===
            this.thumbsBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.hasOwnProperty("thumbsBorderTypeFlag") ? this.options.thumbsBorderTypeFlag : defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderTypeFlag", false, null, this.getRectId)
      }
    },
    thumbsBorderStyle: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderStyle") ? this.options.thumbsBorderStyle : "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderStyle", false, null, this.getRectId)
      }
    },
    thumbsBorderColor: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderColor") ? this.options.thumbsBorderColor : "#000000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderColor", false, null, this.getRectId)
      }
    },
    thumbsBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderIsThemeColor", "thumbsBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderIsThemeColor", false, null, this.getRectId)
      }
    },
    thumbsBorderWidth: {
      get() {
        return this.options.hasOwnProperty("thumbsBorderWidth") ? this.options.thumbsBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderWidth", false, null, this.getRectId)
      }
    },
    thumbsBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("thumbsBoxShadowColor") ? this.options.thumbsBoxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowColor", false, null, this.getRectId)
      }
    },
    thumbsBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("thumbsBoxShadowH") ? this.options.thumbsBoxShadowH : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowH", false, null, this.getRectId)
      }
    },
    thumbsBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("thumbsBoxShadowV") ? this.options.thumbsBoxShadowV : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowV", false, null, this.getRectId)
      }
    },
    thumbsBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("thumbsBoxShadowBlur") ? this.options.thumbsBoxShadowBlur : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowBlur", false, null, this.getRectId)
      }
    },
    thumbsBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("thumbsBoxShadowSpread") ? this.options.thumbsBoxShadowSpread : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowSpread", false, null, this.getRectId)
      }
    },
    // 缩略图选中时的样式
    thumbsActiveOpacity: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveOpacity") ? this.options.thumbsActiveOpacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveOpacity", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderTopLeftRadius")
          ? this.options.thumbsActiveBorderTopLeftRadius
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderTopLeftRadius", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderTopRightRadius")
          ? this.options.thumbsActiveBorderTopRightRadius
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderTopRightRadius", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderBottomRightRadius")
          ? this.options.thumbsActiveBorderBottomRightRadius
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderBottomRightRadius", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderBottomLeftRadius")
          ? this.options.thumbsActiveBorderBottomLeftRadius
          : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderBottomLeftRadius", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderRadius: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderRadius") ? this.options.thumbsActiveBorderRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "thumbsActiveBorderRadius",
            "thumbsActiveBorderTopLeftRadius",
            "thumbsActiveBorderTopRightRadius",
            "thumbsActiveBorderBottomRightRadius",
            "thumbsActiveBorderBottomLeftRadius"
          ],
          false,
          null,
          this.getRectId
        )
      }
    },
    thumbsActiveBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("thumbsActiveBorderTypeFlag")) {
          if (
            ((this.thumbsActiveBorderTopLeftRadius === this.thumbsActiveBorderTopRightRadius) ===
              this.thumbsActiveBorderBottomLeftRadius) ===
            this.thumbsActiveBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.hasOwnProperty("thumbsActiveBorderTypeFlag")
          ? this.options.thumbsActiveBorderTypeFlag
          : defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderTypeFlag", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderStyle: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderStyle") ? this.options.thumbsActiveBorderStyle : "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderStyle", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderColor: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderColor") ? this.options.thumbsActiveBorderColor : "#000000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderColor", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "thumbsActiveBorderIsThemeColor",
          "thumbsActiveBorderIsThemeColor",
          false
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderIsThemeColor", false, null, this.getRectId)
      }
    },
    thumbsActiveBorderWidth: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBorderWidth") ? this.options.thumbsActiveBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBorderWidth", false, null, this.getRectId)
      }
    },
    thumbsActiveBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBoxShadowColor") ? this.options.thumbsActiveBoxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBoxShadowColor", false, null, this.getRectId)
      }
    },
    thumbsActiveBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBoxShadowH") ? this.options.thumbsActiveBoxShadowH : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBoxShadowH", false, null, this.getRectId)
      }
    },
    thumbsActiveBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBoxShadowV") ? this.options.thumbsActiveBoxShadowV : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBoxShadowV", false, null, this.getRectId)
      }
    },
    thumbsActiveBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBoxShadowBlur") ? this.options.thumbsActiveBoxShadowBlur : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBoxShadowBlur", false, null, this.getRectId)
      }
    },
    thumbsActiveBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("thumbsActiveBoxShadowSpread")
          ? this.options.thumbsActiveBoxShadowSpread
          : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsActiveBoxShadowSpread", false, null, this.getRectId)
      }
    },
    slideWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "slideWidth", "slideWidth", 0)
      },
      set(val) {
        this.$changeOptionsEV(val, "slideWidth", false, null, this.getRectId)
      }
    },
    slideHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "slideHeight", "slideHeight", 0)
      },
      set(val) {
        this.$changeOptionsEV(val, "slideHeight", false, null, this.getRectId)
      }
    },
    slideBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "slideBorderRadius", "slideBorderRadius", null)
      },
      set(val) {
        this.$changeOptionsEV(val, "slideBorderRadius", false, null, this.getRectId)
      }
    },
    showRotate: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showRotate", "showRotate", false, null, this.getRectId)
      },
      set(val) {
        this.$changeOptionsEV(val, "showRotate", false, null, this.getRectId)
      }
    },
    getTranslate3() {
      if (this.paginationPosition === "bottom" || this.paginationPosition === "right") {
        this.translate3 = 79.5
      }
      return {
        transform: `translateX(${this.translate3}px)`
      }
    },
    showDirection: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showDirection", "showDirection", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "showDirection", false, null, this.getRectId)
      }
    },
    changeType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "changeType", "changeType", "single")
      },
      set(val) {
        this.$changeOptionsEV(val, "changeType", false, null, this.getRectId)
      }
    },
    getTranslate4() {
      if (this.changeType === "all") this.translate4 = 66
      return {
        transform: `translateX(${this.translate4}px)`
      }
    },
    isDragSlider: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isDragSlider", "isDragSlider", false, null, this.getRectId)
      },
      set(val) {
        this.$changeOptionsEV(val, "isDragSlider", false, null, this.getRectId)
      }
    },
    // 判断当前是双端环境
    isDounbleEnd() {
      const page = this.$store.state[this.request_prefix].page
      if (page.isPhoneFullScreen || page.isOnlyH5Template) {
        return false
      }
      return true
    },
    subpageSetting() {
      const subPages = this.$store.state[this.request_prefix].page.subPages || []
      const subPage = subPages.find(item => item.appId === this.options.appId) || {}
      return subPage
    }
  },
  watch: {
    "subpageSetting.listPageTemplateId": {
      handler: function (val) {
        this.getListSubpageInfo(val)
      },
      deep: false
    },
    "subpageSetting.detailPageTemplateId": {
      handler: function (val) {
        this.getDetailSubpageInfo(val)
      },
      deep: false
    }
  },
  mounted() {

  },
  methods: {
    previewCover() {
      if (!this.cover) return
      if (document.querySelector(".preview-cover")) {
        document.querySelector(".preview-cover").parentNode.remove()
      }
      const previewDom = `
        <div class="preview-cover" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999;background: rgba(0, 0, 0, 0.6);">
          <span class="icon-portal-close-one" style="position: absolute;font-size: 40px;right: 5px; top: 5px;z-index: 10;color: #fff;cursor: pointer" onclick="document.querySelector('.preview-cover').parentNode.remove()"></span>
          <img src="${this.cover}" alt="" style="position: absolute; width: 100%; height: 100%; object-fit: scale-down" />
        </div>
      `
      const previewContainer = document.createElement("div")
      previewContainer.innerHTML = previewDom
      document.getElementById("editPage").appendChild(previewContainer)
    },
    chooseCover() {
      // 选择封面
      document.getElementById(`${this.swiperKey}`).contentWindow.postMessage(
        {
          type: "PortalScreenShot",
          params: {
            componentID: this.swiperKey
          }
        },
        "*"
      )
    },
    handleBgItemUrl: _debounce((value, bgItem) => {
      bgItem.linkUrl = value
    }, 200),
    changePosition(val, idx) {
      if (!val) return
      this.paginationPosition = val
      this.translate3 = idx * 79.5
    },
    //添加轮播content
    addContent() {
      let data = {
        ...this.ids,
        mode: "add"
      }
      delete data.swiperContent_id
      this.$store.dispatch(this.request_prefix + "/swiperContentControl", data)
    },
    startDrag() {
      this.dragging = true
    },
    endDrag() {
      this.dragging = false
    },
    handleCommand(command, type, index) {
      let name = command[0].toUpperCase() + command.substr(1, command.length - 1)
      this.showBgSetDialog = true
      let defaultData = "default" + name
      if (type !== "edit" && this[defaultData]) {
        this.swiperBackground.push(JSON.parse(JSON.stringify(this[defaultData])))
      }
      for (let key in this.showBgSetArr) {
        this.showBgSetArr[key] = "show" + name + "Set" == key ? true : false
      }
      if (name == "Video") {
        this.getUrl()
      }
      let idx = index != undefined ? index : this.swiperBackground.length - 1
      this.bgItemIndex = index
      this.getLocalBg(idx)
    },
    getLocalBg(index) {
      this.bgItem = this.swiperBackground[index]
    },
    handleDel(index) {
      this.swiperBackground = this.swiperBackground.filter((item, idx) => {
        return idx !== index
      })
    },
    closebgSetStatu() {
      this.showBgSetDialog = undefined
    },
    handlePictureCardPreview(file) {},
    handleProgressHandle(response, file) {
      this.percentage = parseInt(file.percentage)
    },
    handleSuccessHandle(response, file, fileList) {
      if (response.result) {
        this.percentage = 0
        this.bgItem.imgUrl = response.data.thumbnail
        this.bgItem.objectId = response.objectId
        this.swiperBackground[this.bgItemIndex] = this.bgItem
        this.showBgSetDialog = false
      } else {
        this.percentage = "error"
      }
    },
    handleFailHandle(err, file, fileList) {},
    // 获取uid
    getUid() {
      let userInfo = this.$store.state.states.userInfo
      if (userInfo) {
        return userInfo.uid
      }
      return new Promise((resolve, reject) => {
        this.$API.getUserInfo().then(res => {
          if (res.data.code === 1) {
            resolve(res.data.data.uid)
          } else {
            reject("err")
          }
        })
      })
    },
    // 获取token
    getToken() {
      return new Promise((resolve, reject) => {
        this.instance.get("usts/yunpan/uservalid").then(res => {
          if (res.status == 200) {
            console.log("res token:>>", res)
            resolve(res.data)
          } else {
            reject("err")
          }
        })
      })
    },
    async getUrl() {
      let token = await this.getToken()
      // let token = "68a97b6e89af8ed91398035f530c4155"
      let uid = await this.getUid()
      this.actionData = {
        uploadtype: "normal",
        puid: uid,
        _from: "cdmh",
        _token: token
      }
    },
    changeSliderLen(flag) {
      if (this.slidesPerView === 1 && flag === 0) {
        return
      }
      if (this.slidesPerView === 10 && flag === 1) {
        return
      }
      this.slidesPerView = flag === 0 ? this.slidesPerView - 1 : this.slidesPerView + 1
    },
    changeContentLen(flag) {
      if (this.swiperContent === 1 && flag === 0) {
        return
      }
      if (this.swiperContent === 99 && flag === 1) {
        return
      }
      this.swiperContent = flag === 0 ? this.swiperContent - 1 : this.swiperContent + 1
    },
    etFocus(event) {
      event.currentTarget.select()
    },
    changeThumbnailLen(flag) {
      if (this.thumbsPerView === 1 && flag === 0) {
        return
      }
      if (this.thumbsPerView === 10 && flag === 1) {
        return
      }
      this.thumbsPerView = flag === 0 ? this.thumbsPerView - 1 : this.thumbsPerView + 1
    },
    changeStatus(val, idx) {
      this.thumbsStatus = val
      this.translate2 = idx * 100.5
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    // 触发首页的保存
    saveDataHandle() {
      document.getElementById("savePage").click()
    },
    async getPublicId() {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = rectAttr?.options?.appId
      if (!appId) return
      const { restUrl } = await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)
      this.publicId = restUrl.data.data.engineInstance.publicId
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "top":
          this.explainTitle = "显示标题栏"
          this.explainTips = "在图文/文本列表的顶部，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-title.png")
          break
        case "left":
          this.explainTitle = "显示左侧栏"
          this.explainTips = "在图文/文本列表的左侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-left.png")
          break
        case "right":
          this.explainTitle = "显示右侧栏"
          this.explainTips = "在图文/文本列表的右侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-right.png")
          break
        case "bottom":
          this.explainTitle = "显示底部栏"
          this.explainTips = "在图文/文本列表的底部，用来放置分页、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-bottom.png")
          break
        case "more":
          this.explainTitle = "显示更多"
          this.explainTips = "在预览页点击点击【更多/查看更多】按钮后，就会进入展示全部数据的列表页"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-more.png")
          break
        case "pagination":
          this.explainTitle = "显示分页"
          this.explainTips = "选择是否需要展示列表中数据的总条数、总页数等"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-paging.png")
          break
        case "shadow":
          this.explainTitle = "投影效果"
          this.explainTips = "开启轮播页的投影"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/shadow-effect.mp4")
          break
        case "button":
          this.explainTitle = "显示切换按钮"
          this.explainTips = "开启后，会显示轮播的切换按钮，点击按钮可以切换轮播上一页、下一页"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/swiper-button.mp4")
          break
        case "indicator":
          this.explainTitle = "显示分页指示器"
          this.explainTips = "开启后，会显示轮播的分页按钮，点击按钮可以切换到对应的轮播页"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/pagination.mp4")
          break
        case "open":
          this.explainTitle = "新页面打开"
          this.explainTips = "开启后，若点击对应的列表页，新页面将会在新窗口打开"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        default:
      }
    }
  }
})
</script>

<style scoped lang="scss">
.swiperComponent {
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
.optionName {
  margin-right: 10px;
  width: auto;
}
.optionItem_switch_box {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
}
.harf_item {
  width: 50% !important;
}
.optionItem {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}
.checkBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.checkBox > div {
  width: 30%;
}
.swiper-content {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: left;
}
::v-deep .el-input-number span {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  height: 93% !important;
}
.swiper-page {

}
.bg-item {
    position: relative;
    height: 32px;
    background: var(--inputBackGround);
    border-radius: 4px;
    margin-top: 8px;
    padding: 0 4px;
    justify-content: space-between;
    &:hover {
      background: var(--inputNuberHoverThemeBgColor);
    }
    &:first-child {
      margin-top: 0;
    }
    .icondrag {
      color: var(--fourthTextColor);
      margin-right: 4px;
      &:hover {
        color: var(--themeColor);
        cursor: grab;
      }
      &.dragging {
        cursor: grabbing;
      }
    }
    .img {
      width: 20px;
      height: 20px;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      overflow: hidden;
      margin-right: 4px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    .text {
      width: calc(100% - 92px);
    }
    .btn-box {
      span {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        color: var(--subTextColor);
        cursor: pointer;
        &:hover {
          background: rgba(31, 35, 41, 0.08);
        }
      }
    }
  }
.add-bg {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  .el-dropdown-link {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    color: var(--themeColor);
    text-align: center;
    line-height: 24px;
    &:hover {
      background: rgba(31, 35, 41, 0.08);
    }
  }
}
.bg-menu {
  .el-dropdown-menu__item {
    line-height: 38px;
    padding: 0 12px;
    img {
      display: inline-block;
      vertical-align: top;
      margin-top: 11px;
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}
::v-deep .chosen {
  background: rgba(43, 103, 255, 0.1) !important;
  border: 1px solid #2b67ff;
  box-shadow: 0px 4px 16px 4px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.02),
    0px 2px 4px -4px rgba(0, 0, 0, 0.02);
}
::v-deep .chosen::after {
  content: "";
  height: 0px;
}
::v-deep .ghost {
  border: none !important;
  box-shadow: none !important;
  background: var(--inputNuberHoverThemeBgColor) !important;
}
::v-deep .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: var(--themeColor);
}
.bg-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: var(--dialogShade);
  z-index: 9999;
}
.bg-set-dialog {
  position: absolute;
  top: 50%;
  right: 0;
  width: 260px;
  padding: 12px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  .tips {
    font-size: 13px;
    line-height: 18px;
    margin: 12px 0 8px;
    color: var(--textColor);
  }
}
.bg-set-dialog .source-type label {
  margin-right: 20px;
}
.video-bgcard {
  display: inline-block;
  vertical-align: top;
  width: 90px;
  height: 90px;
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
}
.video-bgcard > img {
  width: 100%;
  height: 100%;
}
.video-upload-box {
  display: inline-block;
  vertical-align: top;
  margin-left: 16px;
  width: calc(100% - 112px);
}
.video-upload-box .tips {
  margin-bottom: 26px;
  font-size: 12px;
  line-height: 17px;
  color: var(--subTextColor);
}

.video-upload-box ::v-deep .el-upload--picture-card {
  width: 80px;
  height: 28px;
  line-height: 28px;
  border: none;
  background: none;
}
.video-upload-btn {
  width: 80px;
  height: 28px;
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  color: var(--themeColor);
  font-size: 14px;
  line-height: 20px;
  background: transparent;
}
.video-source-box {
  margin-top: 8px;
}

.video-upload-ipt {
  margin-top: 8px;
}
.uploading {
  width: 100%;
  height: 90px;
  background: var(--dataAddActiveBgColor);
  text-align: center;
  padding: 16px 0;
}
.uploading .text {
  font-weight: 600;
  font-size: 14px;
  color: var(--themeColor);
  margin-top: 8px;
  line-height: 20px;
}
.uploadfailed {
  width: 100%;
  height: 100%;
  background: rgba(255, 78, 78, 0.08);
  border: 1px solid #e9e9e9;
  text-align: center;
  color: #ff4e4e;
  padding: 15px;
  font-size: 16px;
}
.uploadfailed .text {
  font-size: 14px;
  line-height: 20px;
}
.mr32 {
  margin-right: 32px;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.swiper-card {
  background: var(--cardBgColor);
  padding: 12px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.font-arrangement-btn.height32 span {
  font-size: 18px;
  height: 26px;
  line-height: 26px;
}
.font-arrangement-btn.height32 span i {
  line-height: 26px;
}
.height32 {
  height: 32px;
}
::v-deep .effect-select .select_title {
  margin-right: 32px;
}
.pagination-set ::v-deep .el-collapse .el-collapse-item {
  background-color: transparent !important;
}
.toolbar .el-tabs .pagination-set ::v-deep .el-collapse .el-collapse-item__header {
  height: 24px;
  padding-left: 18px !important;
  background: transparent !important;
  font-weight: 400;
  margin-top: 12px;
}
.pagination-set.margint0 ::v-deep .el-collapse .el-collapse-item:first-child .el-collapse-item__header {
  margin-top: 0;
}
.pagination-set ::v-deep .el-collapse-item__wrap .el-collapse-item__content {
  padding-left: 18px !important;
}
.pagination-set ::v-deep .el-collapse .el-collapse-item__header .el-collapse-item__arrow {
  left: 0 !important;
}
.width72 ::v-deep .flex_box .el-input {
  width: 72px !important;
}
.width64 ::v-deep .flex_box .el-input {
  width: 64px !important;
}
.width80 ::v-deep .flex_box .el-input {
  width: 80px !important;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  margin-left: 12px;
  .num-btn {
    display: inline-block;
    width: 36px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
    }
  }
}
::v-deep .label56 .slider_and_input .fs14.mr16 {
  width: 56px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.lableWidth4 {
  width: calc(100% - 76px);
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.disabledBtn):hover {
    background: var(--defaultButtonHover);
    cursor: pointer;
  }
  &.is_disabled {
    background: var(--defaultButtonHover);
  }
  .icon-portal-loading1 {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 14px;
    color: var(--topOperationAColor);
    vertical-align: middle;
    margin-top: -2px;
    animation: rotation 1s linear infinite;
    &:before {
      color: var(--topOperationAColor);
    }
  }
  &.disabledBtn {
    cursor: not-allowed;
    border: 1px solid var(--themeColorDisabled);
    color: var(--themeColorDisabled);
  }
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  .img-box {
    width: 100%;
    // height: 122px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: center center;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    &[src=""] {
      opacity: 0;
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 104px;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
      display: flex;
      align-items: center;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    .el-radio {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      white-space: pre-wrap;
    }
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      line-height: 20px;
    }
  }
}
.cover {
  height: 132px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
</style>
